/**
 * 星空(方案 C1):三个深度组 + 上密下疏分布 + 亮星十字光芒 + 免费氛围流星。
 * 整体 alpha × SkyState.starAlpha。
 */
import { Container, Sprite } from 'pixi.js';
import { Stage, LW, LH } from '../engine/Stage';
import { sky } from '../engine/SkyRenderer';
import { TEX } from '../engine/Tex';
import { P } from '../engine/Palette';
import { rand } from '../engine/util';

interface Star { s: Sprite; base: number; ph: number; period: number; twinkle: boolean; bright: boolean; }

export class Starfield {
  private stars: Star[] = [];
  private layer: Container;
  private fall: { s: Sprite; vx: number; vy: number; age: number } | null = null;
  private nextFall = rand(90, 300);
  private t = 0;

  constructor(stage: Stage) {
    this.layer = stage.layers.celestial;
    this.addGroup(140, 0.018, 0.35, 0, false);   // 远星
    this.addGroup(60, 0.032, 0.6, 0.08, false);   // 中星
    this.addGroup(12, 0.05, 0.9, 1, true);        // 亮星(十字)
  }

  private addGroup(n: number, scale: number, alpha: number, twkProb: number, bright: boolean) {
    for (let i = 0; i < n; i++) {
      const s = new Sprite(bright ? TEX.starCross() : TEX.glow());
      s.anchor.set(0.5); s.blendMode = 'add'; s.tint = P.moon;
      s.x = rand(0, LW);
      s.y = Math.pow(Math.random(), 1.6) * LH * 0.72;
      s.scale.set(scale);
      this.stars.push({
        s, base: alpha * rand(0.7, 1), ph: rand(0, 6.28),
        period: bright ? rand(2, 5) : rand(4, 9),
        twinkle: Math.random() < twkProb, bright,
      });
      this.layer.addChild(s);
    }
  }

  update(dt: number) {
    this.t += dt;
    const sa = sky.state.starAlpha;
    for (const st of this.stars) {
      let a = st.base;
      if (st.twinkle) a *= 0.55 + 0.45 * Math.sin((this.t / st.period) * Math.PI * 2 + st.ph);
      st.s.alpha = a * sa;
      if (st.bright && st.twinkle) st.s.scale.set(0.05 * (0.9 + 0.15 * Math.sin(this.t * 1.3 + st.ph)));
    }
    // 免费氛围流星(比神迹流星更慢更暗)
    this.nextFall -= dt;
    if (!this.fall && this.nextFall <= 0 && sa > 0.4) {
      const s = new Sprite(TEX.core()); s.anchor.set(0.5); s.blendMode = 'add'; s.tint = P.moon; s.scale.set(0.08);
      s.position.set(rand(LW * 0.5, LW), rand(0, LH * 0.2));
      this.layer.addChild(s);
      this.fall = { s, vx: -rand(120, 200), vy: rand(90, 150), age: 0 };
      this.nextFall = rand(120, 360);
    }
    if (this.fall) {
      const f = this.fall; f.age += dt;
      f.s.x += f.vx * dt; f.s.y += f.vy * dt;
      f.s.alpha = Math.max(0, (1 - f.age / 2.2)) * sa * 0.7;
      if (f.age > 2.2) { f.s.destroy(); this.fall = null; }
    }
  }
}
